export default "__VITE_ASSET__DKq3GiLm__"